// extracted by mini-css-extract-plugin
module.exports = {"total":"total__2R1NI","fullText":"fullText__2Uc3O","smallText":"smallText__2iDC2","priceContainer":"priceContainer__2sgBS","price":"price__3QoHc","price-old":"price-old__2l7KL"};